import { getFirstQueryParam } from '@jusbrasil-web/shared-utils-url'

type QueryValue = string | string[] | undefined

export interface EntityNoticeParamsQuery {
  entityNoticeVariant?: QueryValue
  entityNoticeEntityId?: QueryValue
  entityNoticePageKind?: QueryValue
}

export const ENTITY_NOTICE_VARIANTS = ['variantA', 'variantB', 'variantC'] as const
export type EntityNoticeVariant = (typeof ENTITY_NOTICE_VARIANTS)[number]

export const ENTITY_NOTICE_PAGE_KINDS = ['own', 'third-party'] as const
export type EntityNoticePageKind = (typeof ENTITY_NOTICE_PAGE_KINDS)[number]

export interface EntityNoticeParams {
  variant: EntityNoticeVariant
  entityId: string | null
  pageKind: EntityNoticePageKind | null
}

export function isEntityNoticeVariant(value: unknown): value is EntityNoticeVariant {
  return typeof value === 'string' && (ENTITY_NOTICE_VARIANTS as readonly string[]).includes(value)
}

export function isEntityNoticePageKind(value: unknown): value is EntityNoticePageKind {
  return (
    typeof value === 'string' && (ENTITY_NOTICE_PAGE_KINDS as readonly string[]).includes(value)
  )
}

/**
 * Closed-set validation of the entity-notice fake-door URL contract. An
 * absent or unrecognized entityNoticeVariant turns the mode off (returns
 * null) rather than throwing — the fake door must never 500 the iframe.
 */
export function resolveEntityNoticeParams(
  query: EntityNoticeParamsQuery
): EntityNoticeParams | null {
  const variant = getFirstQueryParam(query.entityNoticeVariant)
  if (!isEntityNoticeVariant(variant)) return null

  const entityId = getFirstQueryParam(query.entityNoticeEntityId) || null
  const pageKindRaw = getFirstQueryParam(query.entityNoticePageKind)
  const pageKind = isEntityNoticePageKind(pageKindRaw) ? pageKindRaw : null

  return { variant, entityId, pageKind }
}
